<template>
  <div
    :class="$style.container"
    v-text="count"
  ></div>
</template>

<script>
export default {
  name: 'BaseBadge',
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('semi-bold', 12, 14)
    padding: 2px 4px
    background-color: var(--color-red)
    border-radius: 5px
</style>
